// @flow

const botSettingsHomeStyles = {
  root: (theme) => ({
    minHeight: '100vh',
    display: 'flex'
  })
};

export default botSettingsHomeStyles;